import React from "react";
import "../../styles/theme-tokens.css";
import "./titleArea.css";

type TitleAreaTypes = {
  title: string;
  subTitle?: string;
  /**
   * Custom subtitle content for the rare case a plain string won't do
   * (e.g. Support's connection-status line, which needs a colored dot
   * next to the text) — rendered in a <div>, not the <h2> `subTitle`
   * uses, so it can safely hold non-text markup. Takes precedence over
   * `subTitle` when both are given. "page" variant only.
   */
  subTitleContent?: React.ReactNode;
  /**
   * "page" — the big header at the top of a page, directly above its
   * `hr-line` divider (used on all 12 top-level pages). Gets the
   * accent bar + larger heading treatment.
   * "section" (default) — every other, smaller in-page heading this
   * same component is reused for (e.g. aiscreen's/StockAssistant's
   * "Analysis" block, screener's "Filter List" panel, DynamicGraphs'
   * "Parameter"/"Selected Parameter" panels) — unchanged from before,
   * so none of those get sized/spaced for a role they don't play.
   */
  variant?: "page" | "section";
};

export const TitleArea = ({
  title,
  subTitle,
  subTitleContent,
  variant = "section",
}: TitleAreaTypes) => {
  if (variant === "page") {
    return (
      <div className="vi-title-page w-full flex items-start gap-3 !font-dm">
        <span className="vi-title-page-bar" aria-hidden="true" />
        <div className="flex flex-col items-start gap-y-1">
          <h1 className="vi-title-page-h1 font-semibold text-[22px] leading-tight">
            {title}
          </h1>
          {subTitleContent ? (
            <div className="vi-title-page-h2 font-normal text-sm leading-snug">
              {subTitleContent}
            </div>
          ) : (
            subTitle && (
              <h2 className="vi-title-page-h2 font-normal text-sm leading-snug">
                {subTitle}
              </h2>
            )
          )}
        </div>
      </div>
    );
  }

  return (
    <div className=" w-full flex flex-col items-start gap-y-1  !font-dm">
      <h1 className=" font-[500] text-[20px] text-black">{title}</h1>
      <h2 className=" font-normal text-sm text-[#344054]">{subTitle}</h2>
    </div>
  );
};
